import { fetchMediums } from './asyncThunk';
import { getListSlice, initialListState } from '../getListSlice';
import { IListState } from '../types';
import { IMedium } from '../../../api/base/Auth/types';

export type IMediumsState = IListState<IMedium>;

const initialState: IMediumsState = { ...initialListState };

const mediumsSlice = getListSlice({
  moduleName: 'mediums',
  fetchDataThunk: fetchMediums,
  initialState,
});

export const mediumsReducer = mediumsSlice.reducer;
